import { object, string } from 'yup';

const alphaNumericRegEx = RegExp(/^[a-z0-9]+$/i);
const makeInputValidationSchema = object().shape({
  input: string()
    .length(6, 'El número de placa es incorrecto.')
    .matches(alphaNumericRegEx, {
      message: 'Solo se permiten caracteres alfa numéricos.',
      excludeEmptyString: true,
    })
    .required('El número de placa es requerido.'),
});
export default makeInputValidationSchema;
